

// src/components/auth/Auth0ProviderWithHistory.js
import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import InitialAuthCheck from './InitialAuthCheck';

export const Auth0ProviderWithHistory = ({ children }) => {
    const navigate = useNavigate();

    const domain = process.env.REACT_APP_AUTH0_DOMAIN;
    const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
    const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
    const redirectUri = process.env.REACT_APP_AUTH0_REDIRECT_URI;

    console.log('Auth0Provider Environment Variables:', {
        domain,
        audience,
        redirectUri,
    });

    const onRedirectCallback = (appState) => {
        console.log('Auth0 Redirect Callback:', { appState });

        // Handle verification email scenario
        const params = new URLSearchParams(window.location.search);
        const error = params.get('error');
        const description = params.get('error_description');
        const email = params.get('login_hint'); // Auth0 passes email in login_hint

        console.log('Auth0 Callback Parameters:', {
            error,
            description,
            email,
        });

        if (error === 'access_denied' && description?.includes('verify your email')) {
            // Store the email for verification resend
            console.log('Storing pending verification email:', email);
            sessionStorage.setItem('pendingVerificationEmail', email);
        }

        // Navigate to the intended destination
        const destination = appState?.returnTo || '/';
        console.log('Navigating to:', destination);
        navigate(destination);
    };

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={{
                redirect_uri: redirectUri,
                audience: audience,
                scope: "openid profile email"
            }}
            onRedirectCallback={onRedirectCallback}
            cacheLocation="localstorage"
            useRefreshTokens={true}
        >
            <InitialAuthCheck />
            {children}
        </Auth0Provider>
    );
};

export default Auth0ProviderWithHistory;

